import { BaseFetch } from "../main-model"
export default class ReportPurPlanModel extends BaseFetch {
    getReportPurPlanBy = (data) =>
    this.authFetch({
      url: "report-pur-plan/getReportPurPlanBy",
      method: "POST",
      body: JSON.stringify(data),
    })
}
